// extracted by mini-css-extract-plugin
export default {"diff":"DynamicCardDisplay_diff__QbtGh","padding":"DynamicCardDisplay_padding__wswPf"};